import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { API_SERVER } from "../configs/constants.config";

@Injectable({
  providedIn: "root",
})
export class AuraOpsService {
  private apiURL: string = `${API_SERVER.protocol}://${API_SERVER.ip}${API_SERVER.startpoint}/auraOps`;

  constructor(private http: HttpClient) {}
  resolveInvitationToken(body: any): Observable<ResolveTokenResponse> {
    return this.http.post<ResolveTokenResponse>(
      `${this.apiURL}/invitation/token/resolve`,
      body
    );
  }

  syncPolicy(body: any): Observable<any> {
    return this.http.post(`${this.apiURL}/policy/sync`, body);
  }
}

interface ResolveTokenResponse {
  success: boolean;
  email: { recipient: string };
  policy: { policyNumber: string };
  croplands: Cropland[];
  existingUser: ExistingUser | null;
}

interface Cropland {
  cropland_id: number;
  inciso: number;
  name: string;
  locality: string;
  state: string;
  area: number;
  seed_date: Date;
  geometry: Geometry;
  producer_name: string;
  producer_rfc: null;
  producer_curp: null;
  custom_locality: null;
  custom_note: null;
  has_errors: boolean;
  error_list: string;
}

interface Geometry {
  crs: { type: string; properties: { name: string } };
  type: string;
  coordinates: Array<Array<number[]>>;
}

interface ExistingUser {
  id: number;
  email: string;
  fullName: string;
}
